import CXMApiClient from "../../CXMApiClient";

import { HelperFunctions } from "@/lib/utilities/HelperFunctions.js";

function initialState() {
  return {};
}

const state = initialState();

const getters = {};

const actions = {
  pushDealToDealerbuilt: async function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient
      .ProcessRequest(
        "POST",
        "/api/push_to_dms/dealerbuilt/push_deal",
        request,
        scope
      )
      .then(resp => {
        return resp;
      })
      .catch(resp => {
        return resp;
      });
    return response;
  },
  pushProspectToDealerbuilt: async function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/push_to_dms/dealerbuilt/push_prospect",
      request,
      scope
    );

    return response;
  },
  getDealerbuiltLookup: async function(context, request) {
    const scope = HelperFunctions.getCurrentCustomerScope();

    let cxmApiClient = new CXMApiClient();
    let response = await cxmApiClient.ProcessRequest(
      "POST",
      "/api/push_to_dms/dealerbuilt/lookup",
      request,
      scope
    );
    return response;
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/DMSPush/DealerbuiltPush.js